import _ from 'lodash';

export default {
    computed: {
        i18nConfig() {
            return { zhTw: '繁', zhCn: '简', en: 'En' };
        },
        currentI18nKey() {
            return _.chain(this.i18nOptions).get(this.selectedI18n).value();
        },
        i18nOptions() {
            return _.chain(this.i18nConfig).keys().value();
        },
    },
    methods: {
        i18nDefaultValue() {
            return _.mapValues(this.i18nConfig, () => null);
        },
    },
};
